<script setup>
import { computed } from 'vue';
import { useRoute, RouterLink } from 'vue-router';

const props = defineProps({
  title: {
    type: String,
    default: '',
  },
  routerLink: {
    type: String,
    default: '',
  },
  fontawesome: {
    type: String,
    default: '',
  },
});

const route = useRoute();

const isActive = computed({
  get: () => route.name === props.routerLink,
});

defineExpose({
  props,
});
</script>
<template>
  <li class="nav-item mb-1" id="menu-item" :class="{active: isActive}">
    <router-link :to="{name: routerLink}" class="d-flex align-items-center">
      <i :class="fontawesome"></i>
      <span class="menu-title text-truncate">{{ props.title }}</span>
    </router-link>
  </li>
</template>
<style scoped>
#menu-item {
  width: 260px;
}

.vertical-layout.vertical-menu-modern.menu-collapsed .main-menu .menu-title {
  height: 0px;
  visibility: hidden;
}

.vertical-layout.vertical-menu-modern.menu-collapsed .main-menu.expanded .menu-title {
  height: auto;
  visibility: visible;
}
</style>
